import { useState } from "react"
import { router } from "@inertiajs/react"
import { Button } from "@/components/ui/button"
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog"

type Props = {
  open: boolean
  onClose: () => void
  title: string
  description: string
  confirmLabel?: string
  // Either a piece destroy or a group destroy. The DELETE route's URL
  // and the redirect-on-success are owned by the consumer.
  deleteUrl: string
}

// Two-button confirmation modal used for hard-deleting a piece or a brief.
// Refusing the deletion is the default action (Escape, click outside, or
// the Cancel button); confirming requires an explicit click on the danger
// button.
export function ConfirmDeleteDialog({
  open,
  onClose,
  title,
  description,
  confirmLabel = "Delete",
  deleteUrl,
}: Props) {
  const [submitting, setSubmitting] = useState(false)

  const confirm = () => {
    setSubmitting(true)
    router.delete(deleteUrl, {
      preserveScroll: false,
      onSuccess: () => {
        setSubmitting(false)
        onClose()
      },
      onError: () => setSubmitting(false),
    })
  }

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent size="sm">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription>{description}</DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button type="button" variant="ghost" onClick={onClose}>Cancel</Button>
          <Button type="button" variant="danger" onClick={confirm} disabled={submitting}>
            {submitting ? "Deleting…" : confirmLabel}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
